import React, { Component } from "react";
import { Form, Row, Col } from "reactstrap";
import FormComponent from "../../../../common/FormComponent";
import {
  Validator,
  submitValidator,
  refresh,
  valid,
} from "../../../../common/Validator";
import { withRouter } from "react-router-dom";

import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import Button from "@material-ui/core/Button";

import { connect } from "react-redux";
import { getProfileInfo} from "../../../../redux/action/profileInfoAction"

// import { KeyboardReturnTwoTone } from "@material-ui/icons";

/**
 * UpdateExperince Component for updating the experience details.
 */

class UpdateExpirence extends Component {
  constructor(props) {
    super(props);

    this.state = {
    domainExp:
        this.props.data && this.props.data[0]
          ? this.props.data[0].domainExpSum
          : "",
      releventExp:
        this.props.data && this.props.data[0]
          ? this.props.data[0].relYearOfExp
          : "",

      experienceSum:
        this.props.data && this.props.data[0]
          ? this.props.data[0].experienceSumm
          : "",

      id: this.props.data && this.props.data[0]?this.props.data[0].id : undefined,
      message: "",
      error: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);

    
  }

  // common onchange function

  onChange(e) {
    Validator(e.target);
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log(e.target.value);
  }



  // update function by clicking update button

  onUpdate(e) {
    console.log(this.state.id);
    console.log(e, "updating");
    e.preventDefault();
    submitValidator(e.target);
    let data = {
      canInfoId: this.props.profile.data.id,

      domainExpSum: this.state.domainExp,
      relYearOfExp: Number(this.state.releventExp),

      experienceSumm: this.state.experienceSum,
      id: this.state.id,
    };

    console.log(data.id);
    if (valid) {
      axios
        .put(`${API_CANDIDATE}/v1/api/can-exp-summary`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "Updated successfully ",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }
  // submit function by clicking submit button
  onSubmit(e) {
    e.preventDefault();

    submitValidator(e.target);
    console.log();
    let data = {
      canInfoId:this.props.profile.data.id,
    

      domainExpSum: this.state.domainExp,
      relYearOfExp: Number(this.state.releventExp),

      experienceSumm: this.state.experienceSum,
    };
    console.log(data);

    console.log(data);
    if (valid) {
      axios
        .post(`${API_CANDIDATE}/v1/api/can-exp-summary`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "successfully created",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }

 
  componentDidMount() {
    this.props.getProfileInfo();
    refresh();
    this.setState({
      message: "",
      error: "",
    });
  }

  render() {
   
    const {  domainExp, releventExp, experienceSum, message, error } =
      this.state;

    return (
      <>
        {/* applied ternary operator for checking whether it is update or submit form */}
        {!this.props.data.length ? (
          <div style={{ paddingLeft: "2.5rem" }}>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Experience Summary</span>
              </div>
              <div>
                <Form onSubmit={this.onSubmit} className="p-3" noValidate>
                  <Row>
                    <Col>
                      <FormComponent
                        index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Experience Summary"
                        type="textarea"
                        name="experienceSum"
                        inputClass="form-control-sm"
                        value={experienceSum}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="250"
                      />
                        <FormComponent
                        index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Domain Experience Summary"
                        type="textarea"
                        name="domainExp"
                        inputClass="form-control-sm"
                        value={domainExp}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />
                   
                    </Col>
                    <Col>
                  
                      <FormComponent
                       index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Relevant Experience"
                        type="number"
                        name="releventExp"
                        inputClass="form-control-sm"
                        value={releventExp}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="100"
                      />

                  
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                     tabIndex="4"
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Experience Summary</span>
              </div>
              <div>
                <Form onSubmit={this.onUpdate} className="p-3" noValidate>
                  <Row>
                    <Col md="6">
                      <FormComponent
                       index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Experience Summary"
                        type="textarea"
                        name="experienceSum"
                        inputClass="form-control-sm"
                        value={experienceSum}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="250"
                      />
                        <FormComponent
                        index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Relevant Experience"
                        type="number"
                        name="releventExp"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={releventExp}
                        change={this.onChange}
                        required={true}
                      />
                  
                    </Col>
                    <Col md="6">
                    <FormComponent
                       index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Domain Experience Summary"
                        type="textarea"
                        name="domainExp"
                        inputClass="form-control-sm"
                        minlength="2"
                        maxlength="100"
                        value={domainExp}
                        change={this.onChange}
                        required={true}
                      />
                    
                  
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                     tabIndex="4"
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Update
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(
  withRouter(UpdateExpirence)
);

